'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _localforage = require('localforage');

var _localforage2 = _interopRequireDefault(_localforage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function rejectWithMessage(error) {
  return Promise.reject(error.message);
}

exports.default = function (key) {
  var config = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  var replacer = arguments[2];
  var reviver = arguments[3];

  _localforage2.default.config(config);

  return {
    load: function load() {
      return _localforage2.default.getItem(key).then(function (jsonState) {
        return JSON.parse(jsonState, reviver) || {};
      }).catch(rejectWithMessage);
    },
    save: function save(state) {
      return Promise.resolve().then(function () {
        return JSON.stringify(state, replacer);
      }).then(function (jsonState) {
        return _localforage2.default.setItem(key, jsonState);
      }).catch(rejectWithMessage);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-storage-engine-localforage/build/index.js
// module id = uVrr
// module chunks = 3